<template>
  <v-text-field
    id="search-text-term"
    v-if="showSearch"
    v-model.lazy="searchText"
    class="search-field"
    :loading="loadingSearchText"
    prepend-inner-icon="search"
    :background-color="searchIsFocused ? 'white' : 'secondary'"
    :flat="!searchIsFocused"
    placeholder="Buscar processo"
    @focus="searchIsFocused = !searchIsFocused"
    @blur="searchIsFocused = !searchIsFocused"
    solo
    clearable
  >
    <template v-slot:progress>
      <v-progress-linear
        indeterminate
        color="blue"
        height="4"
      ></v-progress-linear>
    </template>
  </v-text-field>
</template>

<script>
  export default {
    name: 'global-search-text-field',
    props: ['showSearch'],
    data() {
      return {
        searchIsFocused: false,
        timeout: null,
        isUserTyping: false,
      };
    },
    computed: {
      loadingSearchText() {
        return this.$store.getters.loadingSearchText;
      },
      searchText: {
        get() {
          return this.$store.getters.searchText;
        },
        set(val) {
          clearTimeout(this.timeout);
          this.isUserTyping = true;
          this.timeout = setTimeout(() => {
            this.isUserTyping = false;
            this.$store.dispatch('setSearchText', val);
            this.$store.dispatch('setLoadingSearchText', true);
          }, 800);
        },
      },
    },
  };
</script>

<style>
  .search-field {
    align-self: flex-end;
    color: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/user-toolbar/GlobalSearchTextField.vue